import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Text } from '@contrast-security-inc/design-system-typography'
import { IconAdd } from '@contrast-security-inc/design-system-foundations'
import { AddExclusionDialog } from './add-exclusion-dialog'
import { ExclusionWrapper } from './exclusion-wrapper'
import { AttackEventForExclusion } from './shared'
import { Button } from '@contrast-security-inc/design-system-buttons'

export const testIds = {
  button: 'add-exclusion-btn'
}

interface Props {
  applicationId: string
  isRASPEnabled: boolean
  organizationUuid: string
  eventForExclusion?: AttackEventForExclusion
  successCallback: (exclusionId: string, shouldSuppressEvents: boolean) => void
}

export function AddExclusionButton({
  applicationId,
  isRASPEnabled,
  organizationUuid,
  successCallback,
  eventForExclusion
}: Props) {
  const intl = useIntl()
  const [isDialogOpen, setIsDialogOpen] = useState(!!eventForExclusion)

  useEffect(() => {
    setIsDialogOpen(!!eventForExclusion)
  }, [eventForExclusion])

  return (
    <ExclusionWrapper
      organizationUuid={organizationUuid}
      applicationId={applicationId}
    >
      {({
        application,
        isFeatureEnabledForAssess,
        isFeatureEnabledForProtect
      }) => (
        <>
          {(isFeatureEnabledForAssess || isFeatureEnabledForProtect) && (
            <Button
              Icon={IconAdd}
              data-testid={testIds.button}
              isDisabled={
                !isFeatureEnabledForProtect &&
                !isRASPEnabled &&
                !isFeatureEnabledForAssess
              }
              onClick={() => setIsDialogOpen(true)}
            >
              <Text font="body">
                {intl.formatMessage({ id: 'title_addExclusion' })}
              </Text>
            </Button>
          )}
          {isDialogOpen && (
            <AddExclusionDialog
              applicationId={applicationId}
              applicationName={application.name}
              applicationLanguage={application.language}
              isAssessFeatureEnabled={isFeatureEnabledForAssess}
              isProtectFeatureEnabled={
                isFeatureEnabledForProtect && isRASPEnabled
              }
              closeDialog={() => setIsDialogOpen(false)}
              organizationUuid={organizationUuid}
              successCallback={successCallback}
              isOpen={true}
              attackEvent={eventForExclusion ?? undefined}
            />
          )}
        </>
      )}
    </ExclusionWrapper>
  )
}
